<app-table
    translatePrefix="sickNotes.assumeSickNote."
    [columns]="columns"
    [items]="store.data.getOtherSickNotes()?.sickNotes || []"
    dataKey="decisionNumber"
    selectionMode="single"
    [showSearchBar]="false"
    (selectionChanged)="selection($event)"
>
</app-table>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons [primaryButtonDisability]="!selectedItem()" primaryButtonLabel="sickNotes.buttons.select"
        (primaryClickEvent)="confirmModal()"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
